import { createContext } from 'react'

const CustomPaletteContext = createContext()

export default CustomPaletteContext
